import { storage } from "../services/firebase/firebaseInit";
import { ref, getDownloadURL } from "firebase/storage";
import JSZip from "jszip";

const getRecordingPath = (auth, callId, date) => {
  const companyId = auth.user.token.claims.company;
  const dateObject = new Date(date);
  const year = dateObject.getUTCFullYear();
  let month = dateObject.getUTCMonth() + 1;
  let day = dateObject.getUTCDate();

  if (month < 10) month = `0${month}`;
  if (day < 10) day = `0${day}`;

  return `${companyId}/${year}/${month}/${day}/${callId}.mp3`;
};

export const downloadRecording = async (auth, callId, date) => {
  try {
    const itemRef = ref(storage, getRecordingPath(auth, callId, date));
    const url = await getDownloadURL(itemRef);

    // Create a link element
    const a = document.createElement("a");
    a.href = url;
    a.target = `_blank`;

    // Append the link to the document
    document.body.appendChild(a);

    // Trigger a click event to start the download
    a.click();

    // Remove the link from the document
    document.body.removeChild(a);

    return true;
  } catch (e) {
    return { error: "Erro ao buscar arquivo." };
  }
};

// items: [{ callId, date }]. Fetches each recording, bundles them into a
// single .zip client-side (no backend endpoint exists for bulk export).
export const downloadRecordingsAsZip = async (auth, items) => {
  const zip = new JSZip();
  const failed = [];

  for (const { callId, date } of items) {
    try {
      const itemRef = ref(storage, getRecordingPath(auth, callId, date));
      const url = await getDownloadURL(itemRef);
      const response = await fetch(url);
      if (!response.ok) throw new Error("download failed");

      const blob = await response.blob();
      zip.file(`${callId}.mp3`, blob);
    } catch (e) {
      failed.push(callId);
    }
  }

  if (Object.keys(zip.files).length === 0) {
    return { error: "Não foi possível baixar as gravações selecionadas.", failed };
  }

  const zipBlob = await zip.generateAsync({ type: "blob" });
  const zipURL = URL.createObjectURL(zipBlob);

  const a = document.createElement("a");
  a.href = zipURL;
  a.download = `gravacoes_${Date.now()}.zip`;

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(zipURL);

  return { failed };
};
